import Axios from "axios";
import React, { useEffect, useState } from "react";
import { storage } from "../../utils";
import utils from "../../components/toastify/toastify";

const emptySelection = {
  free_course_product: "",
  flagship_course_product: "",
};

const ManageHomepageFeatured = () => {
  const [products, setProducts] = useState([]);
  const [selection, setSelection] = useState(emptySelection);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const withToken = (callback) => storage.load("token").then((token) => {
    if (token) callback({ "x-auth": token });
  });

  const loadData = () => withToken((headers) => Promise.all([
    Axios.get("/home", { headers }),
    Axios.get("/get_products", { headers }),
  ]).then(([homeResponse, productsResponse]) => {
    const featured = homeResponse.data?.home_data?.homepage_featured || {};
    setSelection({
      free_course_product: featured.free_course_product || "",
      flagship_course_product: featured.flagship_course_product || "",
    });
    setProducts(productsResponse.data?.products || []);
  }).catch(() => {
    utils.showAlert("تنظیمات صفحه اصلی بارگذاری نشد", "error");
  }).finally(() => setLoading(false)));

  useEffect(() => { loadData(); }, []);

  const save = () => {
    setSaving(true);
    withToken((headers) => Axios.post("/edit_homepage_featured", selection, { headers })
      .then(() => utils.showAlert("محصولات صفحه اصلی ذخیره شد", "success"))
      .catch(() => utils.showAlert("ذخیره تنظیمات ناموفق بود", "error"))
      .finally(() => setSaving(false)));
  };

  const courseProducts = products.filter((product) => product.type !== "results" && product.type !== "videos");
  const renderOptions = () => courseProducts.map((product) => (
    <option key={product._id} value={product._id}>{product.title} ({product.type})</option>
  ));

  return <div className="AddProductContainer">
    <section id="basic-input"><div className="row"><div className="col-md-12"><div className="card"><div className="card-header"><h4 className="card-title">محصولات ویژهٔ صفحه اصلی</h4></div><div className="card-content"><div className="card-body">
      <p className="text-muted mb-2">محصول انتخاب‌شده عنوان، تصویر، قیمت و لینک واقعی خود را در بنر صفحه اصلی نمایش می‌دهد.</p>
      <div className="row">
        <div className="col-md-6 form-group">
          <label htmlFor="free-course-product">بنر دورهٔ رایگان معامله‌گر هوشمند</label>
          <select id="free-course-product" className="form-control" value={selection.free_course_product} onChange={(event) => setSelection({ ...selection, free_course_product: event.target.value })} disabled={loading}>
            <option value="">انتخاب نشده، نمایش نسخهٔ پیش‌فرض</option>
            {renderOptions()}
          </select>
        </div>
        <div className="col-md-6 form-group">
          <label htmlFor="flagship-course-product">دورهٔ پرچم‌دار</label>
          <select id="flagship-course-product" className="form-control" value={selection.flagship_course_product} onChange={(event) => setSelection({ ...selection, flagship_course_product: event.target.value })} disabled={loading}>
            <option value="">انتخاب نشده، نمایش نسخهٔ پیش‌فرض</option>
            {renderOptions()}
          </select>
        </div>
      </div>
      <button type="button" className="btn btn-success mr-1 mb-1" onClick={save} disabled={loading || saving}>{saving ? "در حال ذخیره..." : "ذخیره"}</button>
    </div></div></div></div></div></section>
  </div>;
};

export { ManageHomepageFeatured };
